import Chords from './Chords';

const Progressions = {
  C: {
    name: 'C',
    type: 'scale',
    color: 'text-blue-600',
    chordOrder: ['C', 'G', 'Am', 'F'],
    tempo: 60
  }
  ,D: {
    name: 'D',
    type: 'scale',
    color: 'text-cyan-600',
    chordOrder: ['D', 'A', 'Bm', 'G'],
    tempo: 60
  }
  ,E: {
    name: 'E',
    type: 'scale',
    color: 'text-gray-600',
    chordOrder: ['E', 'B', 'CHm', 'A'],
    tempo: 60
  }
  ,F: {
    name: 'F',
    type: 'scale',
    color: 'text-red-600',
    chordOrder: ['F', 'C', 'Dm', 'Bb'],
    tempo: 60
  }
  ,G: {
    name: 'G',
    type: 'scale',
    color: 'text-purple-600',
    chordOrder: ['G', 'D', 'Em', 'C'],
    tempo: 60
  }
  ,A: {
    name: 'A',
    type: 'scale',
    color: 'text-green-600',
    chordOrder: ['A', 'E', 'FHm', 'D'],
    tempo: 60
  }
  ,B: {
    name: 'B',
    type: 'scale',
    color: 'text-pink-600',
    chordOrder: ['B', 'FH', 'GHm', 'E'],
    tempo: 60
  }
  ,Jonas_Facil: {
    name: 'Jonas facil (D)',
    type: 'song',
    coverUrl: 'jonas',
    chordOrder: ['D', 'D', 'G', 'G'],
    tempo: 130
  }
  ,Jonas: {
    name: 'Jonas (D)',
    type: 'song',
    coverUrl: 'jonas',
    chordOrder: ['D', 'Bm', 'G', 'G'],
    tempo: 130
  }
  ,Todo_Poderoso: {
    name: 'Todo Poderoso (D)',
    type: 'song',
    coverUrl: 'todo_poderoso',
    chordOrder: ['Bm', 'G', 'D', 'A'],
    tempo: 130
  }
  ,Soy_Feliz: {
    name: 'Soy feliz (C)',
    type: 'song',
    coverUrl: 'soy feliz',
    chordOrder: ['F', 'C', 'G', 'Am'],
    tempo: 130
  }
  ,Obrando_En_Mi: {
    name: 'Obrando en mi (F)',
    type: 'song',
    coverUrl: 'obrando en mi',
    chordOrder: ['Dm', 'Bb', 'F', 'C'],
    tempo: 63
  }
  ,Siempre_Que_Me_Muevo: {
    name: 'Siempre que me muevo (E)',
    type: 'song',
    coverUrl: 'nana',
    chordOrder: ['E', 'A', 'B', 'A'],
    tempo: 97
  }
  ,El_Guerrero_David_1: {
    name: 'El guerrero David 1 (C)',
    type: 'song',
    coverUrl: 'david',
    chordOrder: ['C', 'G', 'Am', 'F'],
    tempo: 130
  }
  ,Te_Doy_Gloria: {
    name: 'Te doy gloria (C)',
    type: 'song',
    coverUrl: 'te doy gloria',
    chordOrder: ['C', 'G', 'Am', 'F'],
    tempo: 136
  }
  ,Eres_Increible: {
    name: 'Eres Increible (C)',
    type: 'song',
    coverUrl: 'eres increible',
    chordOrder: ['F', 'C', 'G', 'Am'],
    tempo: 130
  }
  ,Ya_Ya: {
    name: 'Ya Ya (C)',
    type: 'song',
    coverUrl: 'ya ya',
    chordOrder: ['C', 'Am', 'G', 'F'],
    tempo: 94
  }
  ,Ejercicio_1: {
    name: 'Ejercicio 1: D A',
    type: 'exercise',
    chordOrder: ['D', 'A'],
    tempo: 60
  }
  ,Ejercicio_2: {
    name: 'Ejercicio 2: A Bm',
    type: 'exercise',
    chordOrder: ['A', 'Bm'],
    tempo: 60
  }
  ,Ejercicio_3: {
    name: 'Ejercicio 3: Bm G',
    type: 'exercise',
    chordOrder: ['Bm', 'G'],
    tempo: 60
  }
  ,Ejercicio_4: {
    name: 'Ejercicio 4: G D',
    type: 'exercise',
    chordOrder: ['G', 'D'],
    tempo: 60
  }
};

export default Progressions;